import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = async (context) => ({
  redirect: {
    destination: `/admin/meetings/meet/${context.params?.quickMeetId}/edit`,
    permanent: false,
  },
});

export default function AdminQuickMeetEditRedirect() {
  return null;
}
